import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Heading, Button } from '@iclinic/design-system';

import { image } from 'shared/utils/urlGetter';
import { UpdateStepProps } from '../types';
import * as S from './StartStep.styles';
import { checkNextStep } from '../state';

const StartStep = ({ onClose }: UpdateStepProps) => {
  const dispatch = useDispatch();

  const handleNext = () => {
    dispatch(checkNextStep());
  };

  return (
    <>
      <S.Box>
        <img
          src={image('cfmUpdate.start')}
          alt="Início da atualização da regulamentação do CFM"
        />
        <Box mb={1}>
          <Heading variant="md">Atualização cadastral</Heading>
        </Box>

        <S.Body variant="sm">
          A <strong>resolução nº 2.299/2021</strong> do <strong>CFM</strong> e a
          reforma tributária tornaram alguns dados obrigatórios. Por favor,
          preencha suas informações para continuar usando o iClinic.
        </S.Body>
      </S.Box>

      <S.ButtonContainer>
        <Button color="transparent" onClick={onClose}>
          Cancelar
        </Button>
        <Button color="primary" onClick={handleNext}>
          Confirmar
        </Button>
      </S.ButtonContainer>
    </>
  );
};

export default StartStep;
